import { gql } from "@apollo/client";

export const GET_ALL_APP_USERS = gql`
  query GetAllAppUsers($input: GetAppUsersDTO!) {
    getAllAppUsers(input: $input) {
      message
      users {
        _id
        email
        name
        firstName
        lastName
        address
        status
        bio
        access
        lastLoggedInAt
        createdAt
        role
        updatedAt
        contacts {
          dialCode
          number
          email
          emailVerified
        }
        enrollIds
      }
      pagination {
        total
        hasNextPage
      }
    }
  }
`;

export const GET_APP_USER = gql`
  query ($id: String!) {
    getAppUser(id: $id) {
      message
      user {
        _id
        email
        firstName
        lastName
        contacts {
          dialCode
          number
        }
        address
        bio
        status
        access
        role
        lastLoggedInAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_USERS_TO_ENROLL = gql`
query GetAllAppUsers($input: GetAppUsersDTO!) {
  getAllAppUsers(input: $input) {
    message
    pagination {
      total
      hasNextPage
    }
    users {
      _id
      email
      name
      firstName
      lastName
      address
      access
      status
      bio
      lastLoggedInAt
      role
      createdAt
      updatedAt
      enrollIds
      contacts {
        dialCode
        number
        email
        emailVerified
      }
    }
  }
}
`;

export const GET_ENROLLED_DOCTORS_LIST = gql`
  query GetEnrolledDoctorsInNotification(
    $input: BasePaginationParams!
    $notificationTemplateId: String!
  ) {
    getEnrolledDoctorsInNotification(
      input: $input
      notificationTemplateId: $notificationTemplateId
    ) {
      message
      pagination {
        total
        hasNextPage
      }
      users {
        _id
        name
        contacts {
          dialCode
          number
          email
          emailVerified
        }
      }
    }
  }
`;
